import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { InvestModule } from '../invest/invest.module';

import { LiveComponent } from './live.component';
import { LiveSimulatorComponent } from './live-simulator/live-simulator.component';
import { DatatablesComponent } from './datatables/datatables.component';
import { DatatableByPartitionsComponent } from './datatables/datatable-by-partitions/datatable-by-partitions.component';
import { SimulationsComponent } from './simulations/simulations.component';
import { SimulationsListComponent } from './simulations/simulations-list/simulations-list.component';
import { SaveSimulationFormComponent } from './save-simulation-form/save-simulation-form.component';
import { ShareSimulationComponent } from './share-simulation/share-simulation.component';
import { DatatableSummaryComponent } from './datatables/datatable-summary/datatable-summary.component';
import { PartitioningListComponent } from './simulations/partitioning-list/partitioning-list.component';
import { YearSelectFormComponent } from './simulations/year-select-form/year-select-form.component';
import { GaugeDoubleComponent } from './live-simulator/gauge-double/gauge-double.component';
import { GaugesListComponent } from './live-simulator/gauges-list/gauges-list.component';
import { CursorsListComponent } from './live-simulator/cursors-list/cursors-list.component';
import { GaugeComponent } from './live-simulator/gauge/gauge.component';
import { DatatableEditedComponent } from './datatables/datatable-edited/datatable-edited.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        InvestModule
    ],
    entryComponents: [
        ShareSimulationComponent
    ],
    declarations: [
        LiveComponent,
        GaugeDoubleComponent,
        GaugesListComponent,
        LiveSimulatorComponent,
        CursorsListComponent,
        DatatableByPartitionsComponent,
        DatatablesComponent,
        SimulationsComponent,
        SimulationsListComponent,
        SaveSimulationFormComponent,
        ShareSimulationComponent,
        DatatableSummaryComponent,
        PartitioningListComponent,
        YearSelectFormComponent,
        GaugeComponent,
        DatatableEditedComponent
    ]
})
export class LiveModule { }
